import { useState, useEffect } from 'react'
import { productosAPI, inventarioAPI, fmt } from '../services/api'
import toast from 'react-hot-toast'

const FORM_PROD = { nombre:'', codigo:'', codigo_barra:'', precio_bruto:'', categoria_id:'', unidad:'unidad', afecto_iva:true }

export default function Categorias() {
  const [resumen, setResumen]       = useState(null)
  const [productos, setProductos]   = useState([])
  const [seleccion, setSeleccion]   = useState('todos')   // 'todos' | 'sin' | id de categoría
  const [cargando, setCargando]     = useState(true)

  // Modal categoría (crear / renombrar)
  const [modalCat, setModalCat]     = useState(null)      // { id?, nombre }

  // Modal editar producto
  const [editando, setEditando]     = useState(null)      // id del producto
  const [form, setForm]             = useState(FORM_PROD)

  useEffect(() => { cargarTodo(true) }, [])

  const cargarTodo = async (conSpinner = false) => {
    if (conSpinner) setCargando(true)
    try {
      const [r, p] = await Promise.all([
        inventarioAPI.resumenCategorias(),
        productosAPI.listar({ todos: 1, limit: 1000 })
      ])
      setResumen(r.data)
      setProductos(p.data.data)
    } finally { if (conSpinner) setCargando(false) }
  }

  // ── Filtro de productos según la tarjeta seleccionada ──
  const filtrados = productos.filter(p => {
    if (seleccion === 'todos') return true
    if (seleccion === 'sin')   return !p.categoria_id
    return p.categoria_id === seleccion
  })

  const maxCant = resumen
    ? Math.max(1, resumen.sin_categoria, ...resumen.categorias.map(c => c.productos))
    : 1

  // ── Guardar categoría (nueva o renombrar) ──
  const guardarCategoria = async () => {
    if (!modalCat.nombre?.trim()) { toast.error('Escribe el nombre de la categoría'); return }
    try {
      if (modalCat.id) {
        await inventarioAPI.editarCategoria(modalCat.id, { nombre: modalCat.nombre })
        toast.success('Categoría renombrada')
      } else {
        await inventarioAPI.crearCategoria({ nombre: modalCat.nombre })
        toast.success('Categoría creada')
      }
      setModalCat(null)
      cargarTodo()
    } catch {}
  }

  // ── Editar producto ──
  const abrirEditar = p => {
    setForm({ nombre:p.nombre, codigo:p.codigo||'', codigo_barra:p.codigo_barra||'',
      precio_bruto:p.precio_bruto, categoria_id:p.categoria_id||'',
      unidad:p.unidad, afecto_iva:p.afecto_iva })
    setEditando(p.id)
  }

  const guardarProducto = async () => {
    if (!form.nombre || !form.precio_bruto) { toast.error('Nombre y precio son requeridos'); return }
    try {
      await productosAPI.actualizar(editando, form)
      toast.success('Producto actualizado')
      setEditando(null)
      cargarTodo()
    } catch {}
  }

  const nombreSeleccion = seleccion === 'todos' ? 'Todos los productos'
    : seleccion === 'sin' ? 'Sin categoría'
    : resumen?.categorias.find(c => c.id === seleccion)?.nombre || ''

  // ── Tarjeta de categoría ──
  const Tarjeta = ({ id, nombre, cantidad, renombrable }) => {
    const activa = seleccion === id
    return (
      <div
        onClick={() => setSeleccion(id)}
        style={{
          background: activa ? 'var(--color-primary-bg)' : 'var(--color-surface)',
          border: `1px solid ${activa ? 'var(--color-primary)' : 'var(--color-border)'}`,
          borderRadius: 'var(--radius-md)',
          padding: '14px 16px',
          cursor: 'pointer',
          transition: 'all .15s'
        }}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:6}}>
          <span style={{fontSize:13, fontWeight:600, color: activa ? 'var(--color-primary)' : 'var(--color-text)'}}>
            {nombre}
          </span>
          {renombrable && (
            <button
              onClick={e => { e.stopPropagation(); setModalCat({ id, nombre }) }}
              title="Renombrar"
              style={{background:'none', border:'none', cursor:'pointer', color:'var(--color-hint)', fontSize:13, padding:'2px 4px'}}>
              ✎
            </button>
          )}
        </div>
        <div style={{fontSize:20, fontWeight:600, marginBottom:8}}>
          {cantidad} <span style={{fontSize:11, fontWeight:500, color:'var(--color-muted)'}}>productos</span>
        </div>
        <div style={{height:6, background:'var(--color-border)', borderRadius:3, overflow:'hidden'}}>
          <div style={{
            height:'100%', borderRadius:3,
            width: `${Math.round((cantidad / maxCant) * 100)}%`,
            background: 'var(--color-primary)',
            transition: 'width .3s'
          }}/>
        </div>
      </div>
    )
  }

  if (cargando) return <div className="page-loading"><div className="spinner"/></div>

  return (
    <div style={{padding:24}}>
      <div className="flex-between mb-4">
        <div className="section-title" style={{marginBottom:0}}>Categorías</div>
        <button className="btn btn-primary" onClick={() => setModalCat({ nombre:'' })}>
          + Nueva categoría
        </button>
      </div>

      {/* ── Tarjetas ── */}
      <div style={{
        display:'grid',
        gridTemplateColumns:'repeat(auto-fill, minmax(170px, 1fr))',
        gap:12, marginBottom:24
      }}>
        <Tarjeta id="todos" nombre="Todos" cantidad={resumen.total}/>
        {resumen.categorias.map(c => (
          <Tarjeta key={c.id} id={c.id} nombre={c.nombre} cantidad={c.productos} renombrable/>
        ))}
        {resumen.sin_categoria > 0 && (
          <Tarjeta id="sin" nombre="Sin categoría" cantidad={resumen.sin_categoria}/>
        )}
      </div>

      {/* ── Tabla filtrada ── */}
      <div className="section-title" style={{fontSize:13, color:'var(--color-muted)'}}>
        {nombreSeleccion} · {filtrados.length} producto{filtrados.length !== 1 ? 's' : ''}
      </div>
      <div className="table-wrap">
        <table>
          <thead>
            <tr><th>Producto</th><th>SKU</th><th>Precio</th><th>Stock</th><th>Acciones</th></tr>
          </thead>
          <tbody>
            {filtrados.map(p => (
              <tr key={p.id} style={!p.activo ? {opacity:.55} : undefined}>
                <td>
                  <div style={{fontWeight:500}}>{p.nombre}</div>
                  {!p.activo && <span className="badge badge-neutral" style={{marginTop:2}}>Inactivo</span>}
                </td>
                <td style={{color:'var(--color-muted)'}}>{p.codigo || '—'}</td>
                <td style={{fontWeight:600}}>{fmt(p.precio_bruto)}</td>
                <td style={{fontWeight:600}}>{p.stock}</td>
                <td>
                  <button className="btn btn-secondary" style={{padding:'4px 10px',fontSize:12}} onClick={() => abrirEditar(p)}>
                    Editar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {filtrados.length === 0 && (
          <div className="empty-state">
            <h3>Sin productos aquí</h3>
            <p>Esta categoría no tiene productos todavía</p>
          </div>
        )}
      </div>

      {/* ══ MODAL Nueva / Renombrar categoría ══ */}
      {modalCat && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.4)',zIndex:999,display:'flex',alignItems:'center',justifyContent:'center',padding:16}}
          onClick={() => setModalCat(null)}>
          <div className="card" style={{width:'100%',maxWidth:380}} onClick={e => e.stopPropagation()}>
            <div className="section-title">{modalCat.id ? 'Renombrar categoría' : 'Nueva categoría'}</div>
            <div className="form-group">
              <label className="form-label">Nombre</label>
              <input className="form-input" autoFocus value={modalCat.nombre}
                onChange={e => setModalCat({...modalCat, nombre: e.target.value})}
                onKeyDown={e => e.key === 'Enter' && guardarCategoria()}
                placeholder="Ej: Bebidas"/>
            </div>
            <div style={{display:'flex',gap:10}}>
              <button className="btn btn-primary" onClick={guardarCategoria}>
                {modalCat.id ? 'Guardar' : 'Crear'}
              </button>
              <button className="btn btn-secondary" onClick={() => setModalCat(null)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {/* ══ MODAL Editar producto ══ */}
      {editando && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.4)',zIndex:999,display:'flex',alignItems:'center',justifyContent:'center',padding:16}}
          onClick={() => setEditando(null)}>
          <div className="card" style={{width:'100%',maxWidth:640,maxHeight:'92vh',overflowY:'auto'}}
            onClick={e => e.stopPropagation()}>
            <div className="section-title">Editar producto</div>
            <div className="form-row-3">
              <div className="form-group">
                <label className="form-label">Nombre *</label>
                <input className="form-input" autoFocus value={form.nombre} onChange={e=>setForm({...form,nombre:e.target.value})}/>
              </div>
              <div className="form-group">
                <label className="form-label">SKU / Código</label>
                <input className="form-input" value={form.codigo} onChange={e=>setForm({...form,codigo:e.target.value})}/>
              </div>
              <div className="form-group">
                <label className="form-label">Código de barra</label>
                <input className="form-input" value={form.codigo_barra} onChange={e=>setForm({...form,codigo_barra:e.target.value})}/>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Precio con IVA *</label>
                <input className="form-input" type="number" value={form.precio_bruto} onChange={e=>setForm({...form,precio_bruto:e.target.value})}/>
              </div>
              <div className="form-group">
                <label className="form-label">Categoría</label>
                <select className="form-input form-select" value={form.categoria_id} onChange={e=>setForm({...form,categoria_id:e.target.value})}>
                  <option value="">Sin categoría</option>
                  {resumen.categorias.map(c=><option key={c.id} value={c.id}>{c.nombre}</option>)}
                </select>
              </div>
            </div>
            <div style={{display:'flex',gap:10,marginTop:4}}>
              <button className="btn btn-primary" onClick={guardarProducto}>Guardar cambios</button>
              <button className="btn btn-secondary" onClick={() => setEditando(null)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
